<template>
    <!-- ======= 1.08 ctaTwo Area ====== -->
    <div class="ctaTwo" v-if="separator == 'blue'">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <span class="ctaTxtTwo">Registe-se e começe a operar online ainda hoje.</span>
                    <div class="ctaBtn"><a :href="settings.app_url+'/register'" class="btnOne Btn">Regista-te!</a></div>
                </div>
            </div>
        </div>
    </div>
    <!-- ======= /1.08 ctaTwo Area ====== -->

    <!-- ======= 1.03 Domain Area ====== -->
    <div class="domainArea" v-else-if="separator == 'road'">
        <div class="container">
            <div class="row">
                <div class="col-md-12 clearfix">
                    <div class="domainTxt">
                        <p>Ainda não está convencido?<br>Informe-nos o seu email e entraremos em contacto para mais detalhes</p>
                    </div>
                    <form action="#" class="domainForm">
                        <!-- replace domainSearch.html with your php file -->
                        <div class="domainTop">
                            <input type="search" v-model="email" placeholder="Introduza o seu email aqui">
                            <input type="submit" name="submit" value="Enviar" @click.prevent="saveEmail">
                        </div>
                        <!--<div class="domainCheck">-->
                        <!--<span class="com"><input type="checkbox" id="com" name="com"-->
                        <!--value="com"> .com ($8.99) <label for="com"></label></span>-->
                        <!--<span class="net"><input type="checkbox" id="net" name="net" value="net"> .net ($4.99)<label-->
                        <!--for="net"></label></span>-->
                        <!--<span class="org"><input type="checkbox" id="org" name="org"-->
                        <!--value="org"> .org ($11.99)<label for="org"></label></span>-->
                        <!--<span class="in"><input type="checkbox" id="in" name="in" value="in"> .in ($8.99)<label-->
                        <!--for="in"></label></span>-->
                        <!--</div>-->
                    </form>
                </div>
            </div>
        </div>
    </div>
    <!-- ======= /1.03 Domain Area ====== -->
</template>
<script>
  import Settings from '@/database/settings.json'

  export default {
    name: 'site-separator',
    props: ['separator'],
    data() {
      return {
        settings: Settings,
        email: ''
      }
    },
    methods: {
      saveEmail() {
        if (this.email.length > 5) {
        }
      }
    }
  }
</script>

<style scoped>
    .domainArea {
        background: #233141 url(../../assets/images/icon/domain-bg.jpg);
    }
</style>



// WEBPACK FOOTER //
// src/components/site/SiteSeparator.vue